// ==================================================================================
// Digital Approval System (DAS) - Approval Action Endpoints
// ==================================================================================
// API endpoint definitions for approval actions
// ==================================================================================

import { buildEndpoint } from '../base.endpoints';

const BASE_PATH = '/das/requests';

/**
 * Approval action endpoints
 */
export const approvalActionEndpoints = {
  /**
   * Approve a request
   * POST /das/requests/{id}/approve
   */
  approve: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/approve`),

  /**
   * Reject a request
   * POST /das/requests/{id}/reject
   */
  reject: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/reject`),

  /**
   * Escalate a request
   * POST /das/requests/{id}/escalate
   */
  escalate: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/escalate`),

  /**
   * Recommend approval/rejection
   * POST /das/requests/{id}/recommend
   */
  recommend: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/recommend`),

  /**
   * Get users eligible to receive a returned request
   * GET /das/requests/{id}/eligible-return-recipients
   */
  getEligibleReturnRecipients: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/eligible-return-recipients`),

  /**
   * Return for clarification
   * POST /das/requests/{id}/return
   */
  returnForClarification: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/return`),

  /**
   * Resubmit a returned request
   * POST /das/requests/{id}/resubmit
   */
  resubmit: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/resubmit`),

  /**
   * Cancel a request (only by creator)
   * POST /das/requests/{id}/cancel
   */
  cancel: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/cancel`),

  /**
   * Add a comment
   * POST /das/requests/{id}/comments
   */
  addComment: (id: string) => buildEndpoint(`${BASE_PATH}/${id}/comments`),

  // ==================================================================================
  // RETURNED REQUESTS ENDPOINTS
  // ==================================================================================

  /**
   * Get returned requests for current user (as requestor)
   * GET /das/requests/my/returned
   */
  getMyReturned: (topN?: number) => {
    const endpoint = buildEndpoint(`${BASE_PATH}/my/returned`);
    return topN ? `${endpoint}?topN=${topN}` : endpoint;
  },

  /**
   * Get requests returned by current user (as approver)
   * GET /das/requests/my/returned-by-me
   */
  getReturnedByMe: (topN?: number) => {
    const endpoint = buildEndpoint(`${BASE_PATH}/my/returned-by-me`);
    return topN ? `${endpoint}?topN=${topN}` : endpoint;
  },
} as const;
